'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { memoize } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as CustomRenderer from 'UIComponents/utils/propTypes/customRenderer';
import UIList from 'UIComponents/list/UIList';
import ModuleFunctionTagTypes from '../../constants/ModuleFunctionTagTypes';
var getTagI18nKey = memoize(function (tag) {
  return "contentUtils.cmv2Tags." + ModuleFunctionTagTypes[tag];
});

var DefaultTagComponent = function DefaultTagComponent(_ref) {
  var tagTitle = _ref.tagTitle;
  return tagTitle;
};

var ModuleFunctionTagsList = /*#__PURE__*/function (_PureComponent) {
  _inherits(ModuleFunctionTagsList, _PureComponent);

  function ModuleFunctionTagsList() {
    _classCallCheck(this, ModuleFunctionTagsList);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModuleFunctionTagsList).apply(this, arguments));
  }

  _createClass(ModuleFunctionTagsList, [{
    key: "renderTag",
    value: function renderTag(tag, TagComponent) {
      return CustomRenderer.render(TagComponent, {
        key: tag,
        tag: tag,
        tagTitle: React.createElement(FormattedMessage, {
          message: getTagI18nKey(tag)
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          ListComponent = _this$props.listComponent,
          moduleFunctions = _this$props.moduleFunctions,
          TagComponent = _this$props.tagComponent,
          rest = _objectWithoutProperties(_this$props, ["listComponent", "moduleFunctions", "tagComponent"]);

      var renderedTags = moduleFunctions.map(function (tag) {
        return _this.renderTag(tag, TagComponent);
      });
      return React.createElement(ListComponent, rest, renderedTags);
    }
  }]);

  return ModuleFunctionTagsList;
}(PureComponent);

ModuleFunctionTagsList.propTypes = {
  listComponent: CustomRenderer.propType.isRequired,
  moduleFunctions: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(ModuleFunctionTagTypes))).isRequired,
  tagComponent: CustomRenderer.propType.isRequired
};
ModuleFunctionTagsList.defaultProps = {
  listComponent: UIList,
  tagComponent: DefaultTagComponent
};
export default ModuleFunctionTagsList;